import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'
import { CarriersService } from 'src/pages/admin/settings/tracking-providers/carriers.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { createCarrier, createCarrierFailure, createCarrierSuccess, deleteCarrier, deleteCarrierFailure, deleteCarrierSuccess, loadCarriers, loadCarriersFailure, loadCarriersSuccess, updateCarrier, updateCarrierFailure, updateCarrierSuccess } from './carrier.actions'

@Injectable()
export class CarrierEffects {
  private actions$ = inject(Actions)
  private Carriers = inject(CarriersService)
  private toaster = inject(ToasterService)


  loadCarriers$ = createEffect(() => this.actions$.pipe(
    ofType(loadCarriers),
    switchMap(() =>
      from(this.Carriers.getCarriers()).pipe(
        map(carriers => loadCarriersSuccess({ carriers })),
        catchAndLog(this.toaster, 'Unable to fetch carriers', loadCarriersFailure)))))

  createCarrier$ = createEffect(() => this.actions$.pipe(
    ofType(createCarrier),
    tap(() => this.toaster.progress('Creating carrier...')),
    switchMap(action =>
      from(this.Carriers.create(action.carrier)).pipe(
        map(carrier => createCarrierSuccess({ carrier })),
        tap(() => this.toaster.success('Carrier created successfully.')),
        catchAndLog(this.toaster, 'Unable to create carrier', createCarrierFailure)))))

  updateCarrier$ = createEffect(() => this.actions$.pipe(
    ofType(updateCarrier),
    tap(() => this.toaster.progress('Updating carrier...')),
    switchMap(action =>
      from(this.Carriers.update({ carrier_id: action.id, ...action.carrier })).pipe(
        map(carrier => updateCarrierSuccess({ carrier })),
        tap(() => this.toaster.success('Carrier updated successfully.')),
        catchAndLog(this.toaster, 'Unable to update carrier', updateCarrierFailure)))))

  deleteCarrier$ = createEffect(() => this.actions$.pipe(
    ofType(deleteCarrier),
    tap(() => this.toaster.progress('Deleting carrier...')),
    switchMap(action =>
      from(this.Carriers.remove(action.id)).pipe(
        map(r => deleteCarrierSuccess({ id: action.id })),
        tap(() => this.toaster.success('Carrier deleted successfully.')),
        catchAndLog(this.toaster, 'Unable to delete carrier', deleteCarrierFailure)))))
}
